import { Galerie } from '@components/galerie/models';
import { galerieTextMock, imageMock, videoMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

export const galerie4itivMock: Block<Galerie> = {
  type: 'galerie',
  data: {
    layout: '4itiv',
    title: {
      text: `Les tendances [[Fonctionnelles]]`,
      as: 'h2',
    },
    hideLastItem: false,
    items: [
      {
        image: imageMock,
      },
      {
        image: imageMock,
      },
      {
        image: imageMock,
      },
      {
        image: imageMock,
      },
      {
        text: galerieTextMock,
      },
      {
        image: imageMock,
      },
      {
        video: videoMock(),
      },
    ],
  },
};
